<template lang="pug">
	.easy-creative--adjectives.flex-col.space
		.flex-row.space.align-center
			.font-large {{$tCaption('Please specify some adjectives for music selection')}}
		.actions-divider.full-width
		.tb-padding
			Loader(v-if="isLoading", :text="$tCaption('Loading') + '..'")
			.flex-col.space-large(v-else)
				TagEditor(:value="selectedAdjectives", @change="v => selectedAdjectives = v")
		.flex-col.space-medium.full-width
			.actions-divider.full-width
			.flex-row.max-limited.navigation-row.justify-end
				.flex-row.space
					DxButton(:text="$tCaption('Back', '@actions')", @click="$emit('back')", :activeStateEnabled="false", :focusStateEnabled="false")
					DxButton(:text="$tCaption('Next', '@actions')", type="default", @click="$emit('next')", :activeStateEnabled="false", :focusStateEnabled="false", :disabled="!!isLoading")
</template>

<script>
	import Loader from 'app-core/Loader.vue';
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import TagEditor from './EasyCreativeTagEditor.vue';

	export default {
		translationCategory: 'creative.EasyCreative',
		name: 'easy-creative-music-adjectives',
		props: ['info'],
		components: {
			DxButton, Loader, DxTextBox, TagEditor
		},
		data() {
			return {
				isLoading: false,
				selectedAdjectives: [],
				text: null
			};
		},
		computed: {
			
		},
		mounted() {
			if (__DEBUG__)
				window.easyCreativeAdjectives = this;
			
		},
		methods: {
			async onActivate() {
				if (!this.selectedAdjectives?.length || this.info.scriptBuilder().music?.value) {
					await this.generateAdjectives();
				}

				if (this.info.skippedSteps.music) {
					this.$emit('next');
				}
			},
			addTag(text) {
				const val = `${text || this.text || ''}`;
				if (val) {
					const split = val.split(',').filter(f => f);
					this.selectedAdjectives.push(...split);
				}
				setImmediate(() => {
					this.$refs.text.instance._clearValue();
				});
			},
			checkLastKey(e) {
				if ([','].includes(e.event.key)) {
					this.addTag(this.$refs.text.instance._input()[0].value);
				}
			},
			async generateAdjectives() {
				if (this.info.scriptBuilder().music?.value) {
					this.selectedAdjectives = (this.info.scriptBuilder().music?.value).split(',').map(f => this.$Data.capitalize(`${f}`.trim())).filter(f => f);
					if (this.selectedAdjectives?.length) return;
				}
				this.isLoading++;
				const adjectivesString = (await this.$Data.postExternalApi('OpenAiGpt3/GenerateFromPromptWithParameter', {
					promptName: 'Music keywords',
					clientIp: this.$auth.userIP(),
					parameter: this.info.scriptBuilder().scriptText
				}).finally(() => this.isLoading--))?.Data?.Content || '';

				if (adjectivesString) {
					this.selectedAdjectives = adjectivesString.replace(/[\r\n]/g,'').split(',').map(f => `${f || ''}`.trim()).filter(f => f).map(f => this.$Data.capitalize(f));
				}
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";
	.easy-creative--adjectives {
		min-height: 300px;

		@media all and (min-width: 720px) {
			width: 720px;
		}
	}
</style>
